import React from 'react';
import Loading from './Loading';

export default function Preloader() {
  return (
    <div className="is-preloader">
      <Loading />
    </div>
  );
};

